import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "myprofile" }
const _hoisted_2 = { class: "myprofile__inner" }
const _hoisted_3 = { class: "myprofile__grid" }
const _hoisted_4 = { class: "nav-col" }
const _hoisted_5 = { class: "nav-card" }
const _hoisted_6 = { class: "content-col" }
const _hoisted_7 = { class: "content-card" }
const _hoisted_8 = { class: "hero" }
const _hoisted_9 = { class: "hero__meta" }
const _hoisted_10 = { class: "hero__name" }
const _hoisted_11 = { class: "hero__email" }
const _hoisted_12 = { class: "hero__actions" }
const _hoisted_13 = { class: "fields" }
const _hoisted_14 = {
  key: 0,
  class: "text-caption text-warning mb-2"
}
const _hoisted_15 = { class: "actions" }
const _hoisted_16 = { class: "fields" }
const _hoisted_17 = { class: "actions" }
const _hoisted_18 = { class: "actions actions--start" }

import { ref, computed, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import UserForm from '../../../api/v2/forms/user_form'
import { ApiStatus } from '../../../api/v2/api/api_constant'
import { userState } from '../../stores/user'
import { snackBarState } from '../../stores/snackbar'
import { SnackBar } from '../../models/other_models'
import { getQueryString } from '../../../../helpers/route-helper'

const defaultAvt = '/assets/user.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'MyprofileUpdate',
  props: {
    showPreview: { type: Boolean, default: true },
    mode: { default: 'user_update' }
  },
  setup(__props: any) {



const route = useRoute()

const form = ref(new UserForm())
const image = ref<any>(defaultAvt)
const imageInput = ref<HTMLInputElement | null>(null)
const activeSection = ref('profile')
const errorMessageMap = ref<Record<string, string>>({})
const showCurrent = ref(false)
const showNew = ref(false)
const showConfirm = ref(false)

const user = computed(() => userState.user)
const isLoading = computed(() => userState.isLoading)
const errorMessage = computed(() => userState.errorMessage)
const sectionQuery = computed(() => getQueryString(route.query, 'section'))
const hasImage = computed(() => !!image.value && image.value !== defaultAvt)

const getErrorMessageMap = (key: string) => errorMessageMap.value[key]

const notifySuccess = (message: string) => {
  snackBarState.snackbar = new SnackBar(true, message, ApiStatus.SUCCESS)
}

const setUser = () => {
  if (user.value) {
    form.value.name = user.value.name
    form.value.email = user.value.email
    form.value.userBlockId = user.value.userBlockId
    image.value = user.value.image ? user.value.image.url : defaultAvt
  }
}

const setActiveSection = (section: string) => {
  activeSection.value = section
  errorMessageMap.value = {}
}

const uploadImage = () => {
  imageInput.value?.click()
}

const handleImageUpload = (e: Event) => {
  const target = e.target as HTMLInputElement
  const files = target.files || (e as any).dataTransfer?.files
  if (!files?.length) return
  createImage(files[0])
}

const createImage = (file: File) => {
  form.value.image = file
  form.value.deleteImage = false

  const reader = new FileReader()
  reader.onload = (e) => {
    image.value = (e.target as any).result
  }
  reader.readAsDataURL(file)
}

const removeImage = () => {
  image.value = defaultAvt
  form.value.image = null
  form.value.deleteImage = true
}

const saveProfile = async () => {
  const errorMap: Record<string, string> = {}

  if (!form.value.name || form.value.name.indexOf('guest_') != -1) {
    errorMap['name'] = '名前を変更してください'
  }
  if (!form.value.email || form.value.email.indexOf('guest_') != -1) {
    errorMap['email'] = 'メールアドレスを変更してください'
  }
  errorMessageMap.value = errorMap
  if (Object.keys(errorMap).length > 0) return

  if (isLoading.value) return
  await userState.updateUser({ userForm: form.value })
  if (!errorMessage.value) {
    notifySuccess('プロフィールが更新されました')
  }
}

const savePassword = async () => {
  const errorMap: Record<string, string> = {}

  if (!form.value.password) {
    errorMap['password'] = 'パスワードを入力してください'
  }
  if (!form.value.newPassword) {
    errorMap['newPassword'] = '新しいパスワードを入力してください'
  } else if (form.value.newPassword.length < 8) {
    errorMap['newPassword'] = 'パスワードは8文字以上で入力してください'
  }
  if (form.value.password && !form.value.isSamePass) {
    errorMap['newPasswordConfirmation'] = 'パスワード（再入力）とパスワードの入力が一致しません'
  }
  errorMessageMap.value = errorMap
  if (Object.keys(errorMap).length > 0) return

  if (isLoading.value) return
  await userState.updateUser({ userForm: form.value })
  if (!errorMessage.value) {
    form.value.password = ''
    form.value.newPassword = ''
    form.value.newPasswordConfirmation = ''
    notifySuccess('パスワードが更新されました')
  }
}

watch(user, () => {
  setUser()
})

onMounted(async () => {
  if (sectionQuery.value === 'deletion') {
    activeSection.value = 'deletion'
  }
  setUser()
  userState.getUser()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" Settings navigation "),
        _createElementVNode("aside", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["nav-item", { 'nav-item--active': activeSection.value === 'profile' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveSection('profile')))
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-account-circle-outline", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _cache[12] || (_cache[12] = _createElementVNode("span", null, "プロフィール", -1 /* CACHED */))
            ], 2 /* CLASS */),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["nav-item", { 'nav-item--active': activeSection.value === 'account' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveSection('account')))
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("mdi-lock-outline", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _cache[14] || (_cache[14] = _createElementVNode("span", null, "パスワード", -1 /* CACHED */))
            ], 2 /* CLASS */),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "nav-divider" }, null, -1 /* CACHED */)),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["nav-item nav-item--danger", { 'nav-item--active-danger': activeSection.value === 'deletion' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (setActiveSection('deletion')))
            }, [
              _createVNode(_component_v_icon, { size: "20" }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("mdi-account-remove-outline", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              _cache[16] || (_cache[16] = _createElementVNode("span", null, "アカウント削除", -1 /* CACHED */))
            ], 2 /* CLASS */)
          ])
        ]),
        _createCommentVNode(" Settings content "),
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createCommentVNode(" Profile "),
            (activeSection.value === 'profile')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "section-head" }, [
                    _createElementVNode("h2", { class: "section-head__title" }, "プロフィール設定"),
                    _createElementVNode("p", { class: "section-head__desc" }, "基本情報とプロフィール画像を更新できます。")
                  ], -1 /* CACHED */)),
                  _createCommentVNode(" Profile hero "),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_avatar, {
                      size: "80",
                      class: "hero__avatar"
                    }, {
                      default: _withCtx(() => [
                        (hasImage.value)
                          ? (_openBlock(), _createBlock(_component_v_img, {
                              key: 0,
                              src: image.value,
                              cover: ""
                            }, null, 8 /* PROPS */, ["src"]))
                          : (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              size: "44",
                              color: "grey-lighten-1"
                            }, {
                              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                _createTextVNode("mdi-account", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }))
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(form.value.name || 'ー'), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(form.value.email), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_v_btn, {
                          variant: "tonal",
                          color: "primary",
                          size: "small",
                          "prepend-icon": "mdi-camera-outline",
                          onClick: uploadImage
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode(" 画像をアップロード ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _createElementVNode("input", {
                          ref_key: "imageInput",
                          ref: imageInput,
                          type: "file",
                          accept: "image/*",
                          class: "d-none",
                          onChange: handleImageUpload
                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                        (hasImage.value)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              variant: "text",
                              color: "error",
                              size: "small",
                              "prepend-icon": "mdi-delete-outline",
                              onClick: removeImage
                            }, {
                              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                _createTextVNode(" 削除 ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_v_text_field, {
                      modelValue: form.value.name,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.name) = $event)),
                      label: "名前",
                      variant: "outlined",
                      density: "comfortable",
                      "prepend-inner-icon": "mdi-account-outline",
                      "error-messages": getErrorMessageMap('name')
                    }, null, 8 /* PROPS */, ["modelValue", "error-messages"]),
                    (user.value && user.value.unconfirmedEmail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 現在確認中のメールアドレス：" + _toDisplayString(user.value.unconfirmedEmail), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_text_field, {
                      modelValue: form.value.email,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.email) = $event)),
                      label: "メールアドレス",
                      type: "email",
                      autocomplete: "email",
                      variant: "outlined",
                      density: "comfortable",
                      "prepend-inner-icon": "mdi-email-outline",
                      "error-messages": getErrorMessageMap('email')
                    }, null, 8 /* PROPS */, ["modelValue", "error-messages"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      size: "large",
                      loading: isLoading.value,
                      "prepend-icon": "mdi-content-save-outline",
                      onClick: saveProfile
                    }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode(" 変更を保存 ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["loading"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : (activeSection.value === 'account')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" Password "),
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "section-head" }, [
                      _createElementVNode("h2", { class: "section-head__title" }, "パスワード設定"),
                      _createElementVNode("p", { class: "section-head__desc" }, "安全のため、定期的なパスワードの変更をおすすめします。")
                    ], -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_v_text_field, {
                        modelValue: form.value.password,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.password) = $event)),
                        label: "現在のパスワード",
                        type: showCurrent.value ? 'text' : 'password',
                        autocomplete: "current-password",
                        variant: "outlined",
                        density: "comfortable",
                        "prepend-inner-icon": "mdi-lock-outline",
                        "append-inner-icon": showCurrent.value ? 'mdi-eye-off-outline' : 'mdi-eye-outline',
                        "error-messages": getErrorMessageMap('password'),
                        "onClick:appendInner": _cache[6] || (_cache[6] = ($event: any) => (showCurrent.value = !showCurrent.value))
                      }, null, 8 /* PROPS */, ["modelValue", "type", "append-inner-icon", "error-messages"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: form.value.newPassword,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.newPassword) = $event)),
                        label: "新しいパスワード",
                        type: showNew.value ? 'text' : 'password',
                        autocomplete: "new-password",
                        variant: "outlined",
                        density: "comfortable",
                        "prepend-inner-icon": "mdi-lock-plus-outline",
                        "append-inner-icon": showNew.value ? 'mdi-eye-off-outline' : 'mdi-eye-outline',
                        hint: "8文字以上で入力してください",
                        "persistent-hint": "",
                        "error-messages": getErrorMessageMap('newPassword'),
                        "onClick:appendInner": _cache[8] || (_cache[8] = ($event: any) => (showNew.value = !showNew.value))
                      }, null, 8 /* PROPS */, ["modelValue", "type", "append-inner-icon", "error-messages"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: form.value.newPasswordConfirmation,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.newPasswordConfirmation) = $event)),
                        label: "新しいパスワード（確認）",
                        class: "mt-3",
                        type: showConfirm.value ? 'text' : 'password',
                        autocomplete: "new-password",
                        variant: "outlined",
                        density: "comfortable",
                        "prepend-inner-icon": "mdi-lock-check-outline",
                        "append-inner-icon": showConfirm.value ? 'mdi-eye-off-outline' : 'mdi-eye-outline',
                        "error-messages": getErrorMessageMap('newPasswordConfirmation'),
                        "onClick:appendInner": _cache[10] || (_cache[10] = ($event: any) => (showConfirm.value = !showConfirm.value))
                      }, null, 8 /* PROPS */, ["modelValue", "type", "append-inner-icon", "error-messages"]),
                      (errorMessage.value)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "error",
                            variant: "tonal",
                            density: "compact",
                            class: "mt-2",
                            innerHTML: errorMessage.value
                          }, null, 8 /* PROPS */, ["innerHTML"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        size: "large",
                        loading: isLoading.value,
                        "prepend-icon": "mdi-content-save-outline",
                        onClick: savePassword
                      }, {
                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                          _createTextVNode(" パスワードを更新 ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["loading"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : (activeSection.value === 'deletion')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createCommentVNode(" Account deletion "),
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "section-head" }, [
                        _createElementVNode("h2", { class: "section-head__title" }, "アカウント削除"),
                        _createElementVNode("p", { class: "section-head__desc" }, "この操作は取り消すことができません。慎重に行ってください。")
                      ], -1 /* CACHED */)),
                      _createVNode(_component_v_alert, {
                        variant: "tonal",
                        color: "warning",
                        icon: "mdi-alert-outline",
                        class: "deletion-alert"
                      }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createElementVNode("div", { class: "font-weight-bold mb-2" }, "アカウントを削除すると、以下のデータがすべて失われます：", -1 /* CACHED */),
                          _createElementVNode("ul", { class: "deletion-list" }, [
                            _createElementVNode("li", null, "学習履歴やテスト結果"),
                            _createElementVNode("li", null, "購入したコースへのアクセス権"),
                            _createElementVNode("li", null, "保存された学習進捗状況")
                          ], -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_v_btn, {
                          color: "error",
                          variant: "flat",
                          size: "large",
                          "prepend-icon": "mdi-account-remove-outline",
                          to: "/classroom/myprofile/user-account-deletion"
                        }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createTextVNode(" アカウント削除手続きへ進む ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})